import revokeTokenHandler from '../../pattern_utilities/revokeTokenHandler';
import { push } from 'react-router-redux'

var pf_config = require('../../pf_config.json');
var Cookies = require('js-cookie');

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// LOAD PATTERN
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////


export const requestRenderPattern = data => ({
  type: 'REQUEST_RENDER_PATTERN',
  gtag: {
    event_category: 'pattern',
    event_action: 'request'
  },
  data
})

export const receiveRenderPatternSuccess = data => ({
  type: 'RECEIVE_RENDER_PATTERN_SUCCESS',
  gtag: {
    event_category: 'pattern',
    event_action: 'success'
  },
  data
})

export const receiveRenderPatternFail = data => ({
  type: 'RECEIVE_RENDER_PATTERN_FAIL',
  gtag: {
    event_category: 'pattern',
    event_action: 'fail'
  },
  data
})

export const tryToRenderPattern = data => (dispatch, getState) => {
  dispatch(requestRenderPattern(data));

  var headers = { "Content-Type": "application/json" }
  var token = Cookies.get(process.env.REACT_APP_COOKIE_AUTH);
  if(token) headers.Authorization = "Bearer " + token;

  return fetch('/api/patterns/render', {
      method: 'post',
      body: JSON.stringify(data),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      
      if(getState().user.isLoggedIn && getState().user.id == json.scope){
        json.saved = true;
        json.linkedToServer = true;
      }
      
      dispatch(receiveRenderPatternSuccess(json));
    })
    .catch((e, response) => {
      revokeTokenHandler(e);
      dispatch(receiveRenderPatternFail({errors:e, lastSubmit: data}));
    })
}



// WEBPACK FOOTER //
// ./src/actions/pattern/a.p.POST.render-pattern.js